export class UpdateMyRoleTypesModel {
    roleIds: any
}